import saveAs from 'file-saver';
import { DocumentDto, DocumentDtoWithProjectName } from '../components/DocumentList/DocumentList';
import { apiDispatcher } from '../utils';

const baseUrl = '/api/v1/documents';

export const downloadDocument = async (id: string) => {
  apiDispatcher(`${baseUrl}/${id}/DocumentEvent`, 'POST');
  return apiDispatcher<Blob>(`${baseUrl}/${id}/download`, 'GET', undefined, { resolver: (resp) => resp.blob() });
};

export const saveDocument = async (document: DocumentDto | DocumentDtoWithProjectName) => {
  const blob = await downloadDocument(document.id as string);

  // TODO document.name should never be missing.... how do we handle this in a better way? Should we throw an error if the name is missing? It is a null property from the API contract, handle in the FE or BE?
  saveAs(blob, document.name ?? undefined);
};
